import { gql } from '@apollo/client';
import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import { filterByTypename } from '../../utils/graphql';
import usePageQuery, {
  buildQuery,
  UsePageQueryResult,
} from '../../hooks/usePageQuery';
import { CharityRegDetailsFragment } from '../../../types/__generated__';

const FRAGMENT = buildQuery(gql`
  fragment CharityRegDetails on Page {
    relationships {
      beneficiaries(first: 1) {
        nodes {
          ... on Charity {
            id
            registrationNumber
          }
        }
      }
    }
  }
`);

const CharityRegNumber: FunctionComponent = () => {
  const { t } = useTranslation('common', { useSuspense: false });
  const result = usePageQuery<CharityRegDetailsFragment>(FRAGMENT);

  if (!UsePageQueryResult.hasData(result) || !result.data.relationships) {
    return null;
  }

  const charity = result.data.relationships.beneficiaries?.nodes
    ? filterByTypename(result.data.relationships.beneficiaries.nodes, 'Charity')
    : null;

  return (
    <p className="jg-text--small-light" data-qa="charityRegNumber">
      {t('charity.registrationNumberLabel', 'Charity Registration No. ')}{' '}
      {charity?.[0].registrationNumber}
    </p>
  );
};

export default CharityRegNumber;
